<template>
  <div>
    <div class="vx-row">
      <div class="vx-col md-2 w-full">
        <vx-card title="Coupons">
          <vs-button @click="addNewData" color="primary" type="filled"
            >Add Coupons</vs-button
          >
          <vs-table pagination max-items="5" search stripe :data="coupons">
            <template slot="thead">
              <!-- <vs-th sort-key="id">ID</vs-th> -->
              <vs-th sort-key="name">name</vs-th>
              <vs-th sort-key="ctype">Coupon Type</vs-th>
              <vs-th sort-key="ctype">Usage Type</vs-th>
              <vs-th sort-key="ctype">Discount</vs-th>

              <!-- <vs-th sort-key="amount">Discount</vs-th> -->
              <!-- <vs-th sort-key="percentage">Percentage</vs-th> -->
              <!-- <vs-th sort-key="validDays">Valid Days</vs-th> -->
              <vs-th sort-key="createdDate">Valid from</vs-th>
              <vs-th sort-key="expireDate">Valid till</vs-th>
              <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td :data="data[indextr].id">
                  {{ data[indextr].id }}
                </vs-td> -->

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].couponType">
                  {{ data[indextr].couponType }}
                </vs-td>

                <vs-td :data="data[indextr].usageType">
                  {{ data[indextr].usageType }}
                </vs-td>

                <vs-td :data="data[indextr].discountType">
                  {{
                    data[indextr].discountType === 'PERCENTAGE'
                      ? data[indextr].percentageDiscount +
                        ' % Upto ' +
                        data[indextr].maxDiscountAmount +
                        ' ₹'
                      : data[indextr].amountDiscount + ' ₹'
                  }}
                </vs-td>

                <!-- <vs-td :data="data[indextr].amount">
                  {{ data[indextr].amount }}
                </vs-td> -->

                <!-- <vs-td :data="data[indextr].percentage">
                  {{ data[indextr].percentage }}
                </vs-td> -->

                <!-- <vs-td :data="data[indextr].validDays">
                  {{ data[indextr].validDays }}
                </vs-td> -->

                <vs-td :data="data[indextr].validFrom">
                  {{ new Date(data[indextr].validFrom).toLocaleDateString() }}
                </vs-td>

                <vs-td :data="data[indextr].validTill">
                  {{ new Date(data[indextr].validTill).toLocaleDateString() }}
                </vs-td>

                <vs-td>
                  <feather-icon
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current"
                    @click.stop="editData(tr)"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteCoupon(tr)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <!-- add new coupon -->
          <!-- <vs-popup class="holamundo" title="Add New Coupons" :active.sync="couPopupActive">
                   <div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Coupon Name" v-model="couponName" />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-select v-model="couponType" class="w-full select-large" label="Coupon Type">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in couponType" class="w-full" />
                                </vs-select>
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" type="number" label="Amount" v-model="couponAmount" />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" type="number" label="Percentage" v-model="couponPercentage" />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" type="number" label="Valid Days" v-model="couponValidDays" />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                 <label class="text-sm">Created Date</label>
                                <flat-pickr v-model="cdob" :config="{ dateFormat: 'd F Y' }" class="w-full" />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                 <label class="text-sm">Expiry Date</label>
                                <flat-pickr v-model="edob" :config="{ dateFormat: 'd F Y' }" class="w-full" />
                            </div>
                        </div>
                       
                        <div class="vx-row">
                            <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </vs-popup> -->
        </vx-card>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md-2 w-full">
        <vx-card title="Coupons Used">
          <vs-table pagination max-items="5" search stripe :data="couponsUsed">
            <template slot="thead">
              <vs-th sort-key="id">ID</vs-th>
              <vs-th sort-key="id">ID</vs-th>
              <vs-th sort-key="couCode">Code</vs-th>
              <vs-th sort-key="ctype">Type</vs-th>
              <vs-th sort-key="cusName">Customer Name</vs-th>
              <vs-th sort-key="amount">Amount</vs-th>
              <vs-th sort-key="percentage">Percentage</vs-th>
              <vs-th sort-key="validDays">Valid Days</vs-th>
              <vs-th sort-key="expireDate">Expire Date</vs-th>
              <vs-th sort-key="status">Status</vs-th>
              <vs-th>Actions</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].id">
                  {{ data[indextr].id }}
                </vs-td>

                <vs-td :data="data[indextr].couCode">
                  {{ data[indextr].couCode }}
                </vs-td>

                <vs-td :data="data[indextr].ctype">
                  {{ data[indextr].ctype }}
                </vs-td>

                <vs-td :data="data[indextr].cusName">
                  {{ data[indextr].cusName }}
                </vs-td>

                <vs-td :data="data[indextr].amount">
                  {{ data[indextr].amount }}
                </vs-td>

                <vs-td :data="data[indextr].percentage">
                  {{ data[indextr].percentage }}
                </vs-td>

                <vs-td :data="data[indextr].validDays">
                  {{ data[indextr].validDays }}
                </vs-td>

                <vs-td :data="data[indextr].expireDate">
                  {{ data[indextr].expireDate }}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>

                <vs-td>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteUsedCoupon(tr.id)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
    <AddCoupon
      :isPopupActive="addNewDataToPopUp"
      @closePopup="togglePopup"
      :couponData="popupData"
      :productInfo="productInfo"
      :userInfo="userInfo"
    />
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import AddCoupon from '@/views/pages/products/add-coupon.vue'
import moduleCouponManagement from '@/store/coupons/moduleCouponManagement.js'

export default {
  components: {
    flatPickr,
    vSelect,
    AddCoupon
  },
  data() {
    return {
      addNewDataToPopUp: false,
      popupData: {},
      couPopupActive: false,
      selected: [],
      tableList: [
        'vs-th: Component',
        'vs-tr: Component',
        'vs-td: Component',
        'thread: Slot',
        'tbody: Slot',
        'header: Slot'
      ],
      // coupons: [
      //   {
      //     id: 1,
      //     name: 'Free Trial',
      //     ctype: 'Single Use',
      //     amount: '500',
      //     percentage: '-',
      //     validDays: '5',
      //     createdDate: '01 -06-20',
      //     expireDate: '15-06-20'
      //   }
      // ],
      couponsUsed: [
        {
          id: 1,
          couCode: 'ROBSUM90',
          ctype: 'Single Use',
          cusName: 'Pavan Singh',
          amount: '500',
          percentage: '-',
          validDays: '5',
          expireDate: '15-06-20',
          status: 'live'
        }
      ],
      couponType: [
        { text: 'Single Use', value: 'singleuse' },
        { text: 'Multi Use', value: 'multiuse' }
      ]
    }
  },
  methods: {
    togglePopup(val = false) {
      this.addNewDataToPopUp = val
    },
    addNewData() {
      this.popupData = {}
      this.togglePopup(true)
    },
    editData(data) {
      console.log('edita data', data)
      this.popupData = data
      this.togglePopup(true)
    },
    deleteCoupon(data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm Delete',
        text: `You are about to delete "${data.name}"`,
        accept: () => {
          this.showDeleteSuccess(data)
        },
        acceptText: 'Delete'
      })
    },
    showDeleteSuccess(data) {
      this.$store
        .dispatch('coupons/removeCoupon', data._id)
        .then((response) => {
          this.$vs.notify({
            color: 'success',
            title: 'Deleted',
            text: response.data.data
          })
        })
        .catch((err) => {
          console.error(err)
        })
    }
  },
  computed: {
    coupons() {
      return this.$store.state.coupons.coupons
    },
    productList() {
      return this.$store.state.coupons.productList
    },
    userList() {
      return this.$store.state.coupons.userList
    },
    productInfo() {
      if (this.productList) {
        const appendProduct = []
        this.productList.forEach((product) => {
          appendProduct.push({ label: product.name, value: product._id })
        })
        return appendProduct
      } else {
        return []
      }
    },
    userInfo() {
      if (this.userList) {
        console.log('inside userInfo')
        const appendUser = []
        this.userList.forEach((user) => {
          appendUser.push({ label: user.name, value: user._id })
        })
        console.log('appendUser', appendUser)
        return appendUser
      } else return []
    }
  },
  watch: {

  },
  created() {
    if (!moduleCouponManagement.isRegistered) {
      this.$store.registerModule('coupons', moduleCouponManagement)
      moduleCouponManagement.isRegistered = true
    }
    this.$store.dispatch('coupons/fetchCoupons')
    this.$store.dispatch('coupons/fetchProductsInfo')
    this.$store.dispatch('coupons/fetchUsersInfo')
  }
}
</script>
